/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Button, getPayloadObject, getTelemetryAttributes, ITelemetryContent, Waiting } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IBusinessSignUpButtonProps {
    id?: string;
    className: string;
    text: string;
    ariaLabel: string;
    disabled?: boolean;
    link?: string;
    telemetryContent: ITelemetryContent;
    onClick?(event: React.MouseEvent<HTMLElement>): void;
    isLoading?: boolean;
}

export const SignUpButton: React.FC<IBusinessSignUpButtonProps> = ({
    id,
    className,
    text,
    ariaLabel,
    telemetryContent,
    disabled,
    link,
    onClick,
    isLoading
}) => {
    const payLoad = getPayloadObject('click', telemetryContent, text);
    const attributes = getTelemetryAttributes(telemetryContent, payLoad);
    return (
        <>
            <Button
                id={id}
                className={className}
                aria-label={ariaLabel}
                disabled={!!isLoading || !!disabled}
                onClick={onClick}
                role='button'
                aria-disabled={disabled}
                href={link}
                {...attributes}
            >
                {text}
            </Button>
            {isLoading ? (
                <div style={{ alignSelf: 'flex-end' }}>
                    <Waiting className='msc-waiting-circular msc-waiting-sm' />
                </div>
            ) : null}
        </>
    );
};

export default SignUpButton;
